import type { ApprovalPolicy } from '@salescore/agent-contract'

// 入力欄の下で選ぶ承認モード（仕様の「入力欄の操作」）。選んだものはブラウザごとの設定として localStorage に覚え（仕様の「状態の管理」）、
// 指示を送るたびに本文の approvalPolicy で BE に渡す。
// on-request：確認してから反映（SALESCORE を変える MCP のツールの前に承認を求める。runtime の ADR-009）。never：自動で反映（承認を求めない）。
// runtime が受ける untrusted（読み取り以外のコマンドの実行の前にも承認を求める）は、SALESCORE の画面では選べないので持たない
export type AgentApprovalPolicy = Extract<ApprovalPolicy, 'never' | 'on-request'>

// 既定は「確認してから反映」。利用者が確かめないまま、エージェントが SALESCORE を変えないようにする
const DEFAULT_APPROVAL_POLICY: AgentApprovalPolicy = 'on-request'

// 組織を切り替えても別の組織の値を読まないよう、キーに組織 ID を含める
const storageKeyOf = (organizationId: string): string => `salescore:agentWidget:approvalPolicy:${organizationId}`

/**
 * 覚えていた値を承認モードとして読む。覚えていないときと、画面で選べない値（untrusted など）のときは既定にする。
 */
export const parseApprovalPolicy = (saved: string | null): AgentApprovalPolicy =>
  saved === 'never' || saved === 'on-request' ? saved : DEFAULT_APPROVAL_POLICY

// 読めない環境（プライベートブラウズなど）では、既定のモードで送る
export const loadApprovalPolicy = (organizationId: string): AgentApprovalPolicy => {
  try {
    return parseApprovalPolicy(localStorage.getItem(storageKeyOf(organizationId)))
  } catch {
    return DEFAULT_APPROVAL_POLICY
  }
}

export const saveApprovalPolicy = (organizationId: string, approvalPolicy: AgentApprovalPolicy): void => {
  try {
    localStorage.setItem(storageKeyOf(organizationId), approvalPolicy)
  } catch {
    // 覚えられなくても、ページを開いている間は選んだモードで送り（AgentWidget の state）、次に開いたときに既定に戻るだけなので続ける
  }
}
